import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { postErrorSlack } from '../../utils/index.jsx';
import { addBreadcrumb, flush } from '../../utils/diagnostics/breadcrumbs';
import { captureAppState } from '../../utils/diagnostics/appState';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.log("MEEC:"+error+" "+JSON.stringify(info));
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);

    // SHER-499: snapshot the app state at the crash moment (redacted, no PII) so the report says
    // WHAT state the app was in, not just how the user got there.
    const appState = captureAppState();

    try {
      const componentStack = (info && info.componentStack) ? String(info.componentStack).slice(0, 500) : undefined;
      addBreadcrumb('exception', 'error-boundary', {
        errorName: error && error.name,
        errorMessage: error && error.message,
        componentStackSummary: componentStack,
        route: this.props.location && this.props.location.pathname,
        ...appState,
      });
      flush('error-boundary');
    } catch (_) { /* never break fallback UI */ }

    postErrorSlack(this.props.location.pathname, error, info, this.props.investigations.currentInvestigation, appState);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h4>Something went wrong.</h4>;
    }
    return this.props.children;
  }
}

const mapStateToProps = (state) =>{
    return {
        investigations : state.investigations
    }
}

export default withRouter(connect(mapStateToProps, null)(ErrorBoundary));

